module.exports = __webpack_public_path__ + "static/vimy-staked-trees-60a1107cf065b1a04d2c7197cc5c6490.jpg";